import React, { useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';

/**
 * A component that handles the callback from Okta after authentication.
 * It relies on Okta's handleLoginRedirect to manage the redirect.
 *
 * @component
 * @returns {React.Element|null} Renders an error message if authentication fails, otherwise returns null.
 */
const ImplicitCallback = () => {
  const [error, setError] = useState(null);
  const { oktaAuth } = useOktaAuth();

  useEffect(() => {
    const handleAuth = async () => {
      try {
        await oktaAuth.handleLoginRedirect();
      } catch (err) {
        console.error('Authentication error:', err);
        setError(err.toString());
      }
    };

    if (oktaAuth) {
      handleAuth();
    }
  }, [oktaAuth]);

  if (error) {
    return (
      <div>
        <h2>Authentication Error</h2>
        <p>{error}</p>
      </div>
    );
  }

  return null;
};

export default ImplicitCallback;
